import { motion } from "framer-motion";
import { ArrowDown, Lock } from "lucide-react";
import ParticleField from "@/components/three/ParticleField";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      <ParticleField />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 pt-32 pb-20 min-h-[100svh] flex flex-col justify-between">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex items-center gap-3"
        >
          <span className="h-2 w-2 rounded-full bg-[#00FF66] animate-pulse" />
          <span
            data-testid="hero-status"
            className="font-['JetBrains_Mono'] text-[11px] tracking-[0.3em] text-[#A1A1AA]"
          >
            SYSTEM_ONLINE // OPEN_TO_ROLES // OPEN_TO_COLLAB
          </span>
        </motion.div>

        <div className="mt-16">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-['JetBrains_Mono'] text-[11px] tracking-[0.3em] text-[#00FF66] mb-6"
          >
            &gt;_ IDENTIFY_HOST
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            data-testid="hero-title"
            className="font-['Unbounded'] font-black text-5xl sm:text-6xl md:text-7xl lg:text-[8rem] xl:text-[9.5rem] leading-[0.85] tracking-tighter text-[#F5F5F5]"
          >
            RICHIE
            <br />
            <span className="text-[#00FF66]">AKPAN</span>
            <span className="text-[#00FF66] cursor-blink">_</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.55 }}
            className="mt-8 font-['JetBrains_Mono'] text-sm sm:text-base md:text-lg tracking-widest text-[#A1A1AA] max-w-2xl"
          >
            &gt;_ THREAT_INTEL // INCIDENT_RESPONSE // GRC
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.75 }}
          className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 border-t border-white/10 pt-8"
        >
          {[
            { k: "12", v: "CERTS_ATTAINED" },
            { k: "1", v: "IN_PROGRESS" },
            { k: "99th", v: "NCL_PCT_2022" },
            { k: "24/7", v: "DEFEND_MODE" },
          ].map((s) => (
            <div key={s.v} data-testid={`hero-stat-${s.v.toLowerCase()}`}>
              <div className="font-['Unbounded'] font-bold text-3xl md:text-4xl text-[#F5F5F5]">
                {s.k}
              </div>
              <div className="font-['JetBrains_Mono'] text-[10px] tracking-[0.3em] text-[#A1A1AA] mt-2">
                {s.v}
              </div>
            </div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
          className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
        >
          <div className="flex items-center gap-2 font-['JetBrains_Mono'] text-[11px] tracking-[0.3em] text-[#A1A1AA]">
            <Lock size={12} strokeWidth={1.5} className="text-[#00FF66]" />
            AES-256 // PGP_VERIFIED
          </div>
          <div className="flex items-center gap-2 font-['JetBrains_Mono'] text-[11px] tracking-[0.3em] text-[#A1A1AA]">
            SCROLL <ArrowDown size={12} strokeWidth={1.5} className="text-[#00FF66] animate-bounce" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
